export default __webpack_public_path__ + "static/media/Group_11638.85ded425.svg";